export const secondaryConnectionSteps = [
  {
    text: 'In the left sidebar of the Azure Portal, click "App registrations"',
  },
  { text: 'Click "+ New registration"' },
  { text: 'Enter "Microsoft 365 Audit Logs to Blumira" as the name' },
  {
    text: 'Make sure "Accounts in this organizational directory only (* - Single tenant)" is selected',
  },
  { text: 'Leave "Redirect URI" blank' },
  { text: 'At the bottom of the panel, click "Register"' },
  { text: "From the next screen, copy and paste the two fields below:" },
];

export const tertiaryConnectionSteps = [
  { text: 'Click "API Permissions" in the left panel.' },
  { text: 'At the top of the panel, click "Remove Permission."' },
  { text: 'When prompted for confirmation, click "Yes, remove."' },
  {
    text: 'Under the "Configured permissions" section, click "Add a permission."',
  },
  { text: 'Scroll down and click the "Office 365 Management APIs" button.' },
  { text: 'Click the "Application permissions" button.' },
  {
    text: 'Under the "ActivityFeed" section, enable "ActivityFeed.Read" and "ActivityFeed.ReadDlp."',
  },
  { text: 'At the bottom of the panel, click "Add permissions."' },
  {
    text: 'Under the "Configured permissions" section, click "Grant admin consent for."',
  },
  { text: 'When prompted for confirmation, click "Yes."' },
];

export const quaternaryConnectionSteps = [
  { text: 'In the left panel click "Certificates & secrets."' },
  {
    text: 'In the middle of the right panel, click the "New client secret" button.',
  },
  {
    text: 'In the Description field, type a descriptive name such as "Blumira cloud connector."',
  },
  {
    text: "Choose any timeframe you're comfortable with (up to 24 months) - be sure to set a reminder to update this when it expires.",
  },
  { text: 'From the bottom of the panel, click "Add."' },
  { text: 'Copy the Client secret "Value". ("Secret ID" not required)' },
  { text: "Wait for up to one minute before pasting the Client Secret below:" },
];
